@if (showTradingLearnInformation()) {
  <div class="td-wb-trading-learn-information"
       tdWbDataAnalyticsTagging
       [eventSignal]="eventData">
    <td-wb-call-out>
      <td-wb-icon tdWbCallOutIcon
                  iconId="video-play-button"
                  iconType="secondary"
                  size="35">
      </td-wb-icon>
      <div class="td-wb-trading-learn-notification__header">
        <span [translate]="'tdWb.tradingLearn.information.' + tabId + '.DESCRIPTION'"></span>
      </div>
      <a [id]="'td-wb-trading-learn-notification-' + tabId"
         class="td-wb-trading-learn-notification__link"
         tabindex="0"
         role="button"
         (keydown.enter)="contextualLearning.openContextualLearningModal(tabId, page)"
         (click)="contextualLearning.openContextualLearningModal(tabId, page);setAnalytics()">
        <span translate="tdWb.tradingLearn.information.WATCH_THE_VIDEO"></span>
      </a>
    </td-wb-call-out>
    <td-wb-trading-learn-modal #contextualLearning="tdWbContextualLearning">
    </td-wb-trading-learn-modal>
  </div>
}
